import React from 'react';
import PropTypes from 'prop-types';

import TextContent from './TextContent';
import TopicChildren from './TopicChildren';

import colors from './colors';
import styles from './TopicPlatform.module.scss';

const TopicPlatform = ({slug, data, projects}) => (
  <React.Fragment>
    {
      slug === 'coronavirus'
        ? (
          <TextContent
            title={(
              <strong style={{color: colors.black, fontSize: '0.85em'}}>
                O que temos feito para enfrentar a pandemia
              </strong>
            )}>
            <div dangerouslySetInnerHTML={{__html: data.html}} />
          </TextContent>
        )
        : (
          <div style={{height: 30}} />
        )
    }

    <TopicChildren data={projects} />

    {
      data.proposals || data.multi
        ? (
          <section className={styles.proposals}>
            <div className="wrap">
              <div className={styles.wrap}>
                <h3 className={styles.title}>O que Sâmia defende na Câmara Federal</h3>
                {
                  data.multi
                    ? (
                      data.multi.map((item, i) => (
                        <React.Fragment key={i}>
                          <h4 className={styles.subtitle}>{item.title}</h4>
                          <ul className={styles.list}>
                            {item.proposals.map((text, j) =>
                              <li key={j} dangerouslySetInnerHTML={{__html: text}} />,
                            )}
                          </ul>
                        </React.Fragment>
                      ))
                    )
                    : (
                      <ul className={styles.list}>
                        {data.proposals.map((text, i) =>
                          <li key={i} dangerouslySetInnerHTML={{__html: text}} />,
                        )}
                      </ul>
                    )
                }
              </div>
            </div>
          </section>
        )
        : null
    }

    {
      data.done
        ? (
          <section className={styles.done}>
            <div className="wrap">
              <div className={styles.wrap}>
                <h3 className={styles.title}>O que Sâmia fez na Câmara Municipal de São Paulo</h3>
                <ul className={styles.list}>
                  {data.done.map((text, i) =>
                    <li key={i} dangerouslySetInnerHTML={{__html: text}} />,
                  )}
                </ul>
              </div>
            </div>
          </section>
        )
        : null
    }
  </React.Fragment>
);

TopicPlatform.propTypes = {
  slug: PropTypes.string,
  data: PropTypes.object,
  projects: PropTypes.array,
};

export default TopicPlatform;
